module.exports = __webpack_public_path__ + "img/vertical_6_4_0.63f1190f.png";